import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { type WorkspaceAgentPillClip } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPillClipsById';
import { type WorkspaceAgentPillCover } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPillCoversByAssetId';
import { isWorkspaceAgentDirectAssetMonikerPill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentDirectAssetMoniker';

export type ResolvedWorkspaceAgentAssetPillClip = {
  clip: WorkspaceAgentPillClip | undefined;
  /** Version id for a versioned pill, or the cover clip id once an `@[asset:]` moniker has loaded. */
  clipId: string | undefined;
};

export const resolveWorkspaceAgentAssetPillClip = ({
  clipsById,
  coversByAssetId,
  pill,
}: {
  clipsById: ReadonlyMap<string, WorkspaceAgentPillClip> | undefined;
  coversByAssetId: ReadonlyMap<string, WorkspaceAgentPillCover> | undefined;
  pill: WorkspaceAgentMessagePill | undefined;
}): ResolvedWorkspaceAgentAssetPillClip => {
  if (pill?.type !== 'asset') {
    return { clip: undefined, clipId: undefined };
  }

  if (pill.versionId) {
    return { clip: clipsById?.get(pill.versionId), clipId: pill.versionId };
  }

  if (!isWorkspaceAgentDirectAssetMonikerPill(pill)) {
    return { clip: undefined, clipId: undefined };
  }

  const cover = coversByAssetId?.get(pill.assetId);

  return { clip: cover?.clip, clipId: cover?.clipId };
};
